<template>
  <div>
    <h3 class="mb-1 mb-sm-4">
      {{ $t("signup.contact_review_component.signer_title") }}
    </h3>
    <div class="row mb-2 g-2" v-for="field in fields" :key="field.id">
      <label :for="field.id" class="col-sm-3 mt-sm-3 col-form-label">{{
        field.label
      }}</label>
      <div class="col-sm-8 col-10">
        <input
          :type="field.type"
          :id="field.id"
          class="form-control"
          :class="{
            'is-invalid': v$[field.model]?.$error,
          }"
          :disabled="!field.editable"
          v-model="account[field.model]"
          @blur="v$.$touch()"
        />
        <div
          class="invalid-feedback"
          v-for="error of v$[field.model]?.$errors || []"
          :key="error.$uid"
        >
          {{ error.$message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Account, ContactFieldType } from "@/types";
import { BaseValidation } from "@vuelidate/core";

const account = defineModel<Account>({ required: true });

defineProps<{
  fields: ContactFieldType[];
  v$: BaseValidation;
}>();
</script>

<style scoped lang="scss">
.col-form-label {
  text-align: left;
  font-weight: bold;
  padding: 0;
}
.invalid-feedback {
  display: block;
}
.row {
  margin-left: 0;
  margin-right: 0;
}

@media (max-width: 575.98px) {
  .col-form-label {
    margin-top: 1rem;
  }
}
</style>
